import { api, getData } from './request';
import type { Organization } from '@cutr/constants/order';
import type {
  PartnerAnnualGmv,
  PartnerOrganisationListRow,
  PartnerOrganisationProfile,
} from '@cutr/constants/organisations';

export function getPartnerOrganisations(signal?: AbortSignal) {
  return getData<PartnerOrganisationListRow[]>('/v2/organisations', { signal });
}

export function getPartnerAnnualGmv(signal?: AbortSignal) {
  return getData<PartnerAnnualGmv>('/v2/organisations/annual-gmv', { signal });
}

export function getPartnerOrganisationProfile(
  organisationId: string,
  signal?: AbortSignal
) {
  return getData<PartnerOrganisationProfile>(
    `/v2/organisations/${organisationId}/profile`,
    { signal }
  );
}

export function getPartnerOrganisation(
  organisationId: string,
  signal?: AbortSignal
) {
  return getData<Organization>(`/v2/organisations/${organisationId}`, {
    signal,
  });
}

export function deletePartnerOrganisationMember(
  organisationId: string,
  memberId: string
) {
  return api
    .delete(`/v2/organisations/${organisationId}/members/${memberId}`)
    .then(() => undefined);
}
